import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/reducers/global/modal/modalSlice';
import { MODAL_TYPES } from '../modal/modalTypes';

const ExportToExcelButton = ({ children }) => {
  const dispatch = useDispatch();
  const openExcelModal = () => {
    dispatch(openModal({
      modalType: MODAL_TYPES.EXPORT_EDITOR_EXCEL,
      modalProps: {}
    }))
  }

  return (
    <>
      <div onClick={openExcelModal}>
        {children || 'Export to Excel'}
      </div>
    </>
  );
};

export default ExportToExcelButton;
